import { Link } from "@quintype/components";
import React from "react";
import "./not-found.m.css";

const NotFoundPage = () => {
  return (
    <div className="container">
      <div styleName="inner-container">
        <h1 styleName="title">Page Not Found</h1>
        <p styleName="info-text">We are sorry for the inconvenience.</p>
        <Link href="/" styleName="homepage-btn">
          <button>See Latest News</button>
        </Link>
      </div>
    </div>
  );
};

export { NotFoundPage };
